import { Container } from "../atoms/Container";
import { Eyebrow } from "../atoms/Eyebrow";

type SiteCoachProps = {
  mobile?: boolean;
};

export function SiteCoach({ mobile = false }: SiteCoachProps) {
  const pad = mobile ? 24 : 96;
  return (
    <section
      style={{
        paddingTop: mobile ? 80 : 144,
        paddingBottom: mobile ? 80 : 144,
      }}
    >
      <Container pad={pad}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: mobile ? "1fr" : "minmax(0,4fr) minmax(0,8fr)",
            gap: mobile ? 36 : 96,
            alignItems: "start",
          }}
        >
          <Eyebrow>How this works</Eyebrow>
          <div>
            <h2
              style={{
                fontFamily: "var(--display)",
                fontSize: mobile ? "clamp(40px, 10vw, 52px)" : "clamp(48px, 5.5vw, 72px)",
                lineHeight: 1.0,
                letterSpacing: "-0.025em",
                fontWeight: 400,
                color: "var(--text)",
                margin: 0,
              }}
            >
              Your plan will change.
              <br />
              <em
                style={{
                  fontStyle: "italic",
                  color: "var(--accent)",
                }}
              >
                That&apos;s the point.
              </em>
            </h2>

            <p
              style={{
                margin: mobile ? "32px 0 0" : "48px 0 0",
                fontFamily: "var(--ui)",
                fontSize: mobile ? 17 : 18,
                lineHeight: 1.6,
                color: "var(--text)",
                maxWidth: 540,
                letterSpacing: "-0.005em",
              }}
            >
              Every morning we look at your sleep, your recovery, and how your last run went. If
              you&apos;re recovered, we push. If you&apos;re tired, we back off. If you skipped a
              run, we adjust the week — we don&apos;t pile it on.
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
}
